import { AuthPageLayout } from './ui/authPageLayout';

const AuthPage = () => {
  return (
    <AuthPageLayout
      subtitle="Вход на платформу"
      phone="+7 (987) 654-32-10"
      email="organization@domain.ru"
      maxWidth="max-w-lg"
    />
  );
};

export { AuthPage };
